import React from "react";
import BankTransfer from "./BankTransfer";
import Cash from "./Cash";
import Voucher from "./Voucher";
/**
 *
 * @param {string} payment_method
 * @param {string} bank
 * @param {float} amount
 * @param {object} _props formik props
 * @returns
 */
const PaymentMethod = ({ payment_method, bank, amount, _props }) => {
  switch (payment_method) {
    case PaymentMethods.bank_transfer:
      return <BankTransfer bank={bank} amount={amount} _props={_props} />;
    case PaymentMethods.cash:
      return <Cash _props={_props} />;
    case PaymentMethods.voucher:
      return <Voucher _props={_props} />;

    default:
      return <></>;
  }
};

export default PaymentMethod;

export const PaymentMethods = {
  bank_transfer: "bank_transfer",
  cash: "cash",
  voucher: "voucher",
  // paypal: "paypal",
  // online: "online_payment",
};
